export const updateObject = (oldObject, updateValues) => {
        // console.log("oldobject", oldObject);
        // console.log("updatedValues", updateValues);
        return {
                ...oldObject,
                ...updateValues

        }
};